import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { UserSalaryHistoryModel } from 'app/models/user_salary_history.model';

@Injectable({ providedIn: 'root' })
export class UserSalaryHistoryService extends BaseService<UserSalaryHistoryModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'userSalaryHistory');
    }
}
